
interface ColorPreviewProps {
  primaryColor: string;
  accentColor: string;
}

const ColorPreview = ({ primaryColor, accentColor }: ColorPreviewProps) => {
  return (
    <div className="pt-4 space-y-2">
      <h3 className="text-sm font-medium">Preview</h3>
      <div className="p-4 rounded-md border border-border" style={{ backgroundColor: primaryColor }}>
        <div
          className="p-2 rounded-md text-white"
          style={{ backgroundColor: accentColor }}
        >
          Sample Text
        </div>
      </div>
      <div className="bg-card p-4 rounded-md mt-2 border border-border">
        <h4 className="text-sm font-medium mb-2">In current theme:</h4>
        <div className="flex gap-2">
          <div className="h-6 w-12 rounded-md bg-primary"></div>
          <div className="h-6 w-12 rounded-md bg-accent"></div>
        </div>
      </div>
    </div>
  );
};

export default ColorPreview;
